module.exports = __webpack_public_path__ + "static/media/img_3.dd146d3a.png";